import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from '../matchSquads/style.module.scss'

import { useQuery } from '@apollo/client'
import { GET_MATCH_OVERVIEW } from '@graphql/match/match.query'

const XIItems = dynamic(() => import('./XIItems'))

const MatchXI = ({ squadsData, status, matchId }) => {
  const [data, setData] = useState(squadsData)
  const [isPlaying11Team1, setIsPlaying11Team1] = useState(false)
  const [isPlaying11Team2, setIsPlaying11Team2] = useState(false)

  const { data: matchXIdata } = useQuery(GET_MATCH_OVERVIEW, { variables: { input: { iMatchId: matchId } } })

  useEffect(() => {
    setIsPlaying11Team1(false)
    setIsPlaying11Team2(false)
    data?.oTeam1?.aPlayers?.some(player => player?.bPlaying11) && setIsPlaying11Team1(true)
    data?.oTeam2?.aPlayers?.some(player => player?.bPlaying11) && setIsPlaying11Team2(true)
  }, [data])

  useEffect(() => {
    if (matchXIdata?.getMatchOverviewFront) {
      setData(matchXIdata?.getMatchOverviewFront)
    }
  }, [matchXIdata])

  return (
    <section className="content-visibility-auto">
      {/* {JSON.stringify(data)} */}
      {(data?.oTeam1?.aPlayers?.length > 0 || data?.oTeam2?.aPlayers?.length > 0) && (
        <>
          <h6 className="text-capitalize">{isPlaying11Team1 || isPlaying11Team2 ? 'Squads' : 'Squads'}</h6>
          <div className="d-flex flex-column gap-2">
            {data?.oTeam1?.aPlayers?.length > 0 && (
              <div className={`${styles.content} d-flex flex-wrap justify-content-between`}>
                <section className={`${styles.matchSquads} common-box p-0`}>
                  <div className={styles.squadHead}>
                    <p className="text-primary font-bold mb-0">{`${data?.oTeam1?.oTeam?.sTitle}`}</p>
                  </div>
                  <div className={styles.content}>
                    <div className={`${styles.list} font-semi overflow-hidden`}>
                      <div className={`${styles.item} d-flex flex-column flex-md-row gap-1 mb-4`}>
                        {isPlaying11Team1 ? <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>{'Playing XI'}</p> : null}
                        {/* <p className="mb-0"> */}
                        {status !== 'scheduled' && (
                          <>
                            <div className="d-flex flex-wrap">
                              {data?.oTeam1?.aPlayers?.map((player, index) => {
                                if (player?.bPlaying11 && !player?.bSubstitute) {
                                  return (
                                    <React.Fragment key={index}>
                                      <XIItems data={player} styles={styles} />
                                    </React.Fragment>
                                  )
                                } else {
                                  return null
                                }
                              })}
                            </div>
                          </>
                        )}
                        {status === 'scheduled' && (
                          <div className="d-flex flex-wrap">
                            {data?.oTeam1?.aPlayers?.map((benchPlayer, index) => {
                              // if (!benchPlayer?.bPlaying11) {
                              return (
                                <React.Fragment key={index}>
                                  <XIItems key={index} data={benchPlayer} styles={styles} />
                                </React.Fragment>
                              )
                              // } else {
                              //   return null
                              // }
                            })}
                          </div>
                        )}
                        {/* </p> */}
                      </div>
                      {status !== 'scheduled' && data?.oTeam1?.aPlayers?.some(player => player?.bSubstitute && player?.bPlaying11) && (
                        <div className={`${styles.item} d-flex flex-column flex-md-row gap-1 mb-4`}>
                          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>{'Impact'}</p>
                          {/* <p className="mb-0"> */}
                          <div className="d-flex flex-wrap">
                            {data?.oTeam1?.aPlayers?.map((benchPlayer, index) => {
                              if (benchPlayer?.bSubstitute && benchPlayer?.bPlaying11) {
                                return (
                                  <React.Fragment key={index}>
                                    <XIItems data={benchPlayer} styles={styles} />
                                  </React.Fragment>
                                )
                              } else {
                                return null
                              }
                            })}
                          </div>
                          {/* </p> */}
                        </div>
                      )}
                      {status !== 'scheduled' && data?.oTeam1?.aPlayers?.some(player => player?.bSubstitute) && (
                        <div className={`${styles.item} d-flex flex-column flex-md-row gap-1 mb-4`}>
                          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>{'Substitutes'}</p>
                          {/* <p className="mb-0"> */}
                          <div className="d-flex flex-wrap">
                            {data?.oTeam1?.aPlayers?.map((benchPlayer, index) => {
                              if (benchPlayer?.bSubstitute && !benchPlayer?.bPlaying11) {
                                return (
                                  <React.Fragment key={index}>
                                    <XIItems data={benchPlayer} styles={styles} />
                                  </React.Fragment>
                                )
                              } else {
                                return null
                              }
                            })}
                          </div>
                          {/* </p> */}
                        </div>
                      )}
                      {status !== 'scheduled' && data?.oTeam1?.aPlayers?.some(player => !player?.bPlaying11 && !player?.bSubstitute) && (
                        <div className={`${styles.item} d-flex flex-column flex-md-row gap-1`}>
                          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>{'Reserve'}</p>
                          {/* <p className="mb-0"> */}
                          <div className="d-flex flex-wrap">
                            {data?.oTeam1?.aPlayers?.map((benchPlayer, index) => {
                              if (!benchPlayer?.bPlaying11 && !benchPlayer?.bSubstitute) {
                                return (
                                  <React.Fragment key={index}>
                                    <XIItems data={benchPlayer} styles={styles} />
                                  </React.Fragment>
                                )
                              } else {
                                return null
                              }
                            })}
                          </div>
                          {/* </p> */}
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            )}
            {data?.oTeam2?.aPlayers?.length > 0 && (
              <div className={`${styles.content} d-flex flex-wrap justify-content-between`}>
                <section className={`${styles.matchSquads} common-box p-0`}>
                  <div className={styles.squadHead}>
                    <p className="text-primary font-bold mb-0">{`${data?.oTeam2?.oTeam?.sTitle}`}</p>
                  </div>
                  <div className={styles.content}>
                    <div className={`${styles.list} font-semi overflow-hidden`}>
                      <div className={`${styles.item} d-flex flex-column flex-md-row gap-1 mb-4`}>
                        {isPlaying11Team2 ? <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>{'Playing XI'}</p> : null}
                        {/* <p className="mb-0"> */}
                        {status !== 'scheduled' && (
                          <>
                            <div className="d-flex flex-wrap">
                              {data?.oTeam2?.aPlayers?.map((player, index) => {
                                if (player?.bPlaying11 && !player?.bSubstitute) {
                                  return (
                                    <React.Fragment key={index}>
                                      <XIItems data={player} styles={styles} />
                                    </React.Fragment>
                                  )
                                } else {
                                  return null
                                }
                              })}
                            </div>
                          </>
                        )}
                        {status === 'scheduled' && (
                          <div className="d-flex flex-wrap">
                            {data?.oTeam2?.aPlayers?.map((benchPlayer, index) => {
                              // if (!benchPlayer?.bPlaying11) {
                              return (
                                <React.Fragment key={index}>
                                  <XIItems key={index} data={benchPlayer} styles={styles} />
                                </React.Fragment>
                              )
                              // } else {
                              //   return null
                              // }
                            })}
                          </div>
                        )}
                        {/* </p> */}
                      </div>
                      {status !== 'scheduled' && data?.oTeam2?.aPlayers?.some(player => player?.bSubstitute && player?.bPlaying11) && (
                        <div className={`${styles.item} d-flex flex-column flex-md-row gap-1 mb-4`}>
                          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>{'Impact'}</p>
                          {/* <p className="mb-0"> */}
                          <div className="d-flex flex-wrap">
                            {data?.oTeam2?.aPlayers?.map((benchPlayer, index) => {
                              if (benchPlayer?.bSubstitute && benchPlayer?.bPlaying11) {
                                return (
                                  <React.Fragment key={index}>
                                    <XIItems data={benchPlayer} styles={styles} />
                                  </React.Fragment>
                                )
                              } else {
                                return null
                              }
                            })}
                          </div>
                          {/* </p> */}
                        </div>
                      )}
                      {status !== 'scheduled' && data?.oTeam2?.aPlayers?.some(player => player?.bSubstitute) && (
                        <div className={`${styles.item} d-flex flex-column flex-md-row gap-1`}>
                          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>{'Substitutes'}</p>
                          {/* <p className="mb-0"> */}
                          <div className="d-flex flex-wrap">
                            {data?.oTeam2?.aPlayers?.map((benchPlayer, index) => {
                              if (benchPlayer?.bSubstitute && !benchPlayer?.bPlaying11) {
                                return (
                                  <React.Fragment key={index}>
                                    <XIItems data={benchPlayer} styles={styles} />
                                  </React.Fragment>
                                )
                              } else {
                                return null
                              }
                            })}
                          </div>
                          {/* </p> */}
                        </div>
                      )}
                      {status !== 'scheduled' && data?.oTeam1?.aPlayers?.some(player => !player?.bPlaying11 && !player?.bSubstitute) && (
                        <div className={`${styles.item} d-flex flex-column flex-md-row gap-1 mt-4`}>
                          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>{'Reserve'}</p>
                          {/* <p className="mb-0"> */}
                          <div className="d-flex flex-wrap">
                            {data?.oTeam2?.aPlayers?.map((benchPlayer, index) => {
                              if (!benchPlayer?.bPlaying11 && !benchPlayer?.bSubstitute) {
                                return (
                                  <React.Fragment key={index}>
                                    <XIItems data={benchPlayer} styles={styles} />
                                  </React.Fragment>
                                )
                              } else {
                                return null
                              }
                            })}
                          </div>
                          {/* </p> */}
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            )}
          </div>
        </>
      )}
    </section>
  )
}

MatchXI.propTypes = {
  squadsData: PropTypes.object,
  status: PropTypes.string,
  matchId: PropTypes.string
}

export default MatchXI
